import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Advance Payments is built. Reached from
// Payroll > Disbursement > Advance Payments in the sidebar flyout.
export const DisbursementAdvancePayments = () => <NotImplemented title="Advance Payments" />;
